import { render, staticRenderFns } from "./VirtualPackingSlipOrderDetails.vue?vue&type=template&id=f27bc7aa&"
import script from "./VirtualPackingSlipOrderDetails.vue?vue&type=script&lang=js&"
export * from "./VirtualPackingSlipOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports